import type { ReactNode } from "react";
import { PageLayout } from "../PageLayout";
import AppHeader from "features/common/components/AppHeader";

export interface AuthenticatedLayoutProps {
  children: ReactNode;
  fullWidth?: boolean;
}

export const AuthenticatedLayout = (props: AuthenticatedLayoutProps) => {
  const { children, fullWidth = false } = props;

  return (
    <PageLayout fullWidth={fullWidth}>
      <AppHeader authenticated />
      {children}
    </PageLayout>
  );
};
